import { apiCall } from './gqlClient';

const TRAININGMESOCYCLES_QUERY = `
  query trainingMesocycles($providerId: Float!) {
    trainingMesocycles(providerId: $providerId)
    {
      id
			providerId
			name
			description
			phase
			focus
			prog
			microLen
			public
			active
			archive
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const trainingMesocyclesApiCall = async ({providerId}, fragments = null) => apiCall({ query: TRAININGMESOCYCLES_QUERY, variables: {providerId}, fragments });

const TRAININGMESOCYCLE_QUERY = `
  query trainingMesocycle($id: String!) {
    trainingMesocycle(id: $id)
    {
      id
			providerId
			name
			description
			phase
			focus
			prog
			microLen
			public
			active
			archive
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const trainingMesocycleApiCall = async ({id}, fragments = null) => apiCall({ query: TRAININGMESOCYCLE_QUERY, variables: {id}, fragments });

const CREATETRAININGMESOCYCLE_QUERY = `
  mutation createTrainingMesocycle($input: TrainingMesocycleInput!) {
    createTrainingMesocycle(input: $input)
    {
      id
			providerId
			name
			description
			phase
			focus
			prog
			microLen
			public
			active
			archive
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const createTrainingMesocycleApiCall = async ({input}, fragments = null) => apiCall({ query: CREATETRAININGMESOCYCLE_QUERY, variables: {input}, fragments });

const UPDATETRAININGMESOCYCLE_QUERY = `
  mutation updateTrainingMesocycle($id: String!, $input: TrainingMesocycleInput!) {
    updateTrainingMesocycle(id: $id, input: $input)
    {
      id
			providerId
			name
			description
			phase
			focus
			prog
			microLen
			public
			active
			archive
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const updateTrainingMesocycleApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATETRAININGMESOCYCLE_QUERY, variables: {id, input}, fragments });

const DELETETRAININGMESOCYCLE_QUERY = `
  mutation deleteTrainingMesocycle($id: String!) {
    deleteTrainingMesocycle(id: $id)
    {
      id
			providerId
			name
			description
			phase
			focus
			prog
			microLen
			public
			active
			archive
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const deleteTrainingMesocycleApiCall = async ({id}, fragments = null) => apiCall({ query: DELETETRAININGMESOCYCLE_QUERY, variables: {id}, fragments });
